export default __webpack_public_path__ + "static/hand-86bced1ab297779b2b51cad3c375939b.png";